import { useMemo } from 'react';
import { isExpiredResetDate } from '@/helpers/date';
import { useGetInvestingStatus } from '@/query/queries/investing/useGetInvestingStatus';

export const useRoundStatus = () => {
  const { data: status, isLoading } = useGetInvestingStatus();

  const isParticipating = useMemo(
    () =>
      status?.is_active &&
      status?.step === 3 &&
      !!status?.has_accepted_necessary_terms,
    [status],
  );

  const addOnly = !!(
    status?.step === 3 &&
    isParticipating &&
    isExpiredResetDate(status.editable_until)
  );

  const isActive = !!status?.is_active;
  const isRoundProcessing = status?.step === 4;
  const minInvestAmount = status?.min_investment_amount;

  return {
    status,
    addOnly,
    minInvestAmount,
    isActive,
    isParticipating,
    isRoundProcessing,
    isLoading,
  };
};
